<template>
  <div>
    <h1>Company Selector</h1>
    
    <el-input 
      ref="search"
      placeholder="Search..." 
      v-model="search" 
      prefix-icon="el-icon-search" 
      :autofocus="true" 
    />
    <br><br>
    <table class="table table-striped">
      <tbody>
        <tr @click="switchCompany(company)" v-for="company in filteredItems" :key="company.id">
          <td>
            <a>{{ company.title }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CompanySelector',
  data: () => ({
    search: '',
  }),
  computed: {
    filteredItems() {
      return this.companies.filter(
        company => company.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1,
      );
    },
  },
  props: {
    companies: {
      type: Array,
      default: [],
    },
  },
  methods: {
    switchCompany(company) {
      this.$emit('onSwitchCompany', { company: company.id });
    },
  },
};
</script>




// WEBPACK FOOTER //
// CompanySelector.vue?8bf2fdaa